<template>
    <div class="">
        <el-page-header @back="toListPage">
            <p slot="content" class="font14px text-bold">批量编辑角色：去除权限</p>
        </el-page-header>
        <el-divider></el-divider>
        <div class="form-wrap">
            <el-form ref="form" :model="formItem" :rules="rules" label-width="120px">
                <el-form-item label="已选角色：">
                    <span>{{list.map(item=>item.role_name).join('、')}}</span>
                </el-form-item>
                <el-form-item label="" label-width="50px" class="min-height-300">
                    <div class="pr20 add-role-page" v-loading="dataLoading">
                        <CollapseCard
                            :config="operationConfig"
                            :active="activeNames"
                            @title-check-all="handleTitleCheckAll"
                            @change-page="handleChangeModule"
                            @change-module="handleChangeModule"
                            @show-modal="showCollapseModal"
                            @remove-parent-checked="removeParentChecked"
                        ></CollapseCard>
                    </div>
                </el-form-item>
                <el-form-item label="" label-width="0">
                    <div class="form-footer tac mt20">
                        <el-button type="default" class="action-btn mr20" @click="toListPage">取消</el-button>
                        <el-button type="primary" class="submit-btn action-btn ml20" :loading="submitLoading"
                                   @click="handleSubmit">保存
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <FieldsModal
            ref="fieldsModal"
            :fields="actionFields"
            :actionType="actionType"
            :page="actionPage"
            @save-fields="handleSaveFields"

        ></FieldsModal>
        <ConfigOptionalRoleModal
            ref="configOptionalRoleModal"
            :page="actionPage"
            @save-roles="handleSaveOptionalRoles"
        />
        <TagFieldsModal
            ref="tagFieldsModal"
            :fields="actionFields"
            :page="actionPage"
            :tag-editable="tagActionIdsEditable"
            @save-tag-fields="handleSaveTagFields"
            @save-fields="handleSaveTagFields"/>

        <StatisticalPeriodModal
            ref="statisticalPeriodModal"
            :is-remove="true"
            :page="actionPage"
            :fields="actionFields"
            @save="handleSavePeriodAction"
        />
    </div>
</template>

<script>
    import API from '@/api/role.js';
    import utils from '@/libs/utils.js';
    import CollapseCard from '../components/collapseCard';
    import FieldsModal from '../modal/batchRemoveModal/roleFields.vue';
    import TagFieldsModal from '../modal/batchRemoveModal/tagFields.vue';
    import ConfigOptionalRoleModal from '../modal/batchRemoveModal/configOptionalRole';
    import StatisticalPeriodModal from '../modal/statisticalPeriodModal';

    export default {
        name: "BatchRemove",
        props:{
            list:Array,
        },
        components:{
            CollapseCard,
            FieldsModal,
            ConfigOptionalRoleModal,
            TagFieldsModal,
            StatisticalPeriodModal,
        },
        data(){
            return {
                test:true,
                dataLoading:false,
                submitLoading:false,
                operationConfig:[],     // 页面与操作权限配置
                formItem:{
                    special_config:{
                        optional_role:'',
                        tag_action_ids_editable:'',
                        /* 自动化报告-统计周期 */
                        statistical_period:{
                            customize_the_latest_days:'',
                            customize_the_start_date:'',
                        },
                    },
                },
                rules:{

                },
                activeNames:[],
                actionPage:{},
                actionFields:[],
                actionType:'',
                tagActionIdsEditable:{},
            }
        },
        created(){
            let routeQuery = this.$route.query || {};
            console.log('batchRemove created',routeQuery);
            let roleList = this.list||[];
            if(roleList.length<=0){
                this.toListPage();
            }else{
                this.getConfig();
            }
        },
        methods:{
            toListPage(){
                this.$emit('togglePage','listPage');
                let routeParams = this.$route.params || {};
                let original = routeParams.original;
                this.$router.replace({
                    name: 'role_management',
                    query: {
                        action: 'list',
                        t: +new Date(),
                    },
                    params:{
                        original:original,
                    }
                });
            },
            getConfig() {
                this.dataLoading = true;
                return API.getAddRoleConfig().then(res => {
                    let resData = res.data || {};
                    let operationConfig = resData.operation_config || [];
                    this.activeNames = operationConfig.map(item=>item.id);
                    this.operationConfig = this._fmtTreeData(operationConfig);

                    /*配置可选角色时会用到*/
                    this.$store.commit('roleData/SET_ROLE_LIST', resData.role_list || []);
                    this.dataLoading = false;
                }, (err) => {
                    console.log('getConfig error', err);
                    this.operationConfig = [];
                    this.activeNames = [];
                    this.dataLoading = false;
                });
            },
            handleSubmit(){
                console.log('handleSubmit',this.formItem);

                this.formItem.special_config.tag_action_ids_editable = this.tagActionIdsEditable;
                let data = {
                    type:'0',       // 0-去除权限，1-增加权限
                    special_config: JSON.stringify(this.formItem.special_config),
                    role_ids:this.list.map(item=>item.role_id).join(','),
                };

                // 权限id '13,14,15,32,16,17,18'
                let actionIds = this._getCheckedVal(this.operationConfig,[]);


                data.action_ids = utils.unique(actionIds).join(',');
                console.log(11111,actionIds,this.formItem.special_config.optional_role);
                let tagEditable = this.formItem.special_config.tag_action_ids_editable||{};
                if(data.action_ids.length<=0&&this.formItem.special_config.optional_role.length<=0&&Object.values(tagEditable).length<=0){
                    return this.$message.error('请选择要去除的权限');
                }

                this.submitLoading = true;

                API.batchEditRole(data).then(res => {
                    this.$message.success(res.info || '操作成功');
                    this.submitLoading = false;
                    this.toListPage();
                }, (err) => {
                    console.log('addRole error', err);
                    let errData = err.data||[];
                    if(err.code==0&&errData.length>0){
                        this.$notify.error({
                            title: err.info||'请求失败',
                            message: errData.join('；'),
                            duration: 0
                        });
                    }else{
                        this.$message.error(err.info||'操作失败');
                    }
                    this.submitLoading = false;
                });
            },
            handleTitleCheckAll(module){
                console.log('title-check-all',module);
                this._setChildrenVal(module,true);
            },
            handleChangeModule(module,val){
                console.log('handleChangeModule change-module',val,module);
                this._setChildrenVal(module,val);
            },
            removeParentChecked(module){
                this.$set(module,'checked',false);
                this._removeParentsChecked(module);
            },
            showCollapseModal(page,type){
                if(type=='dimensions'){
                    this.actionPage = page;
                    this.actionFields = page.dimension||[];
                    this.actionType = 'dimensions';
                    this.$refs.fieldsModal.showModal();
                }else if(type=='fields'){
                    this.actionPage = page;
                    this.actionFields = page.fields||[];
                    this.actionType = 'fields';
                    this.$refs.fieldsModal.showModal();
                }else if(type=='configOptionalRole'){
                    this.actionPage = page;
                    this.actionType = '';
                    this.actionFields = [];
                    this.$refs.configOptionalRoleModal.showModal();
                }else if(type=='tag-fields'){
                    console.log('tag-fields page',page);
                    this.actionPage = page;
                    this.actionFields = page.fields||[];
                    this.actionType = 'tag-fields';
                    this.$refs.tagFieldsModal.showModal();
                }else if(type == 'period'){
                    this.actionPage = page;
                    this.actionFields = page.statistical_period||[];
                    let periodConfig = this.formItem.special_config.statistical_period||{};
                    this.$refs.statisticalPeriodModal.showModal(periodConfig);
                }
            },
            getPlatDailyTaskFields(page){
                console.log('getPlatDailyTaskFields',page);
                let allowPlats = this.allowActions.plat_ids||[];
                let fieldsArr = page.fields||[];
                return fieldsArr.filter(item=>{
                    let platItem = (item.name||'').match(/\d+/)||[];
                    let pagePlatId = platItem[0]||'';
                    return allowPlats.includes(pagePlatId);
                }).map(item=>{
                    let platItem = (item.name||'').match(/\d+/)||[];
                    let pagePlatId = platItem[0]||'';
                    let allowDataType = this.allowActions.data_type||{};
                    let platDataType = allowDataType[pagePlatId]||[];

                    item.children = (item.children||[]).filter(inner=>{
                        return platDataType.includes(inner.mid);
                    });
                    return item;
                });
            },
            handleSaveFields(page,val,type) {
                // console.log('save-fields',val,page);
                let targetPage = this._findModuleById(this.operationConfig, page.id);
                let fields = type=='fields'?targetPage.fields:targetPage.dimension;
                let selectedVal = val;

                let allFieldsCnt = 0;

                fields.forEach(item=>{
                    this.$set(item,'checked',selectedVal.includes(item.id));
                    allFieldsCnt++;
                    if(item.children&&item.children.length>0){
                        let itemChild = item.children;
                        itemChild.forEach(item2=>{
                            allFieldsCnt++;
                            this.$set(item2,'checked',selectedVal.includes(item2.id));
                            if(item2.children&&item2.children.length>0){
                                let item2Child = item2.children;
                                item2Child.forEach(item3=>{
                                    allFieldsCnt++;
                                    this.$set(item3,'checked',selectedVal.includes(item3.id));
                                    if(item3.children&&item3.children.length>0){
                                        let item3Child = item3.children;
                                        item3Child.forEach(item4=>{
                                            allFieldsCnt++;
                                            this.$set(item4,'checked',selectedVal.includes(item4.id));
                                        })
                                    }
                                })
                            }
                        })
                    }
                });

                console.log('allFieldsCnt',allFieldsCnt);
                if(val.length<allFieldsCnt){
                    this.$set(page,'checked',false);
                    this._removeParentsChecked(page);
                }
            },
            handleSaveTagFields(page,viewChecked,editChecked){
                console.log('save-tag-fields',page,viewChecked,editChecked);
                this.handleSaveFields(page,viewChecked.map(item=>item.id),'fields');
                this.$nextTick(()=>{
                    if(editChecked.length>0){
                        this.$set(this.tagActionIdsEditable,page.id,editChecked.join(','));
                    }else if(this.tagActionIdsEditable[page.id]){
                        delete this.tagActionIdsEditable[page.id];
                    }
                });
            },
            handleSaveOptionalRoles(module,val){
                console.log('handleSaveOptionalRoles',module,val);
                this.$set(module,'optional_role_val',val);
                this.formItem.special_config.optional_role = val.join(',');
            },
            handleSavePeriodAction(module,data){
                console.log('handleSavePeriodAction',module,data);
                let targetPage = this._findModuleById(this.operationConfig, module.id);
                let selectedVal = data.period||[];
                let fields = targetPage.statistical_period||[];
                fields.forEach(item=>{
                    this.$set(item,'checked',selectedVal.includes(item.id));
                });

                let periodConfig = this.formItem.special_config.statistical_period||{};
                this.$set(periodConfig,'customize_the_latest_days',data.data_days||'');
                this.$set(periodConfig,'customize_the_start_date',data.start_date||'');
            },
            _fmtTreeData(data) {
                data.forEach((v) => {
                    if (v.children && v.children.length > 0) {
                        this._fmtTreeData(v.children)
                    }
                    /* 页面节点 */
                    if (v.type == '1') {
                        if (v.func && v.func.length > 0) {
                            this._fmtTreeData(v.func)
                        }
                        if (v.fields && v.fields.length > 0) {
                            this._fmtTreeData(v.fields)
                        }
                        if (v.dimension && v.dimension.length > 0) {
                            this._fmtTreeData(v.dimension)
                        }
                        if(v.special_func&&v.special_func.length>0){
                            let specialFuncArr = v.special_func||[];
                            if(specialFuncArr.findIndex(item=>item.name=='optional_role')!='-1'){
                                this.$set(v, 'optional_role_val', []);
                            }
                        }
                    }
                });
                return data;
            },
            _setChildrenVal(module,val){
                // console.log('_setChildrenVal',module.display_name,val,module);
                if(!module.disabled){
                    this.$set(module,'checked',val);
                }
                if(module.children&&module.children.length>0){
                    let children = module.children;
                    children.forEach(child=>{
                        this._setChildrenVal(child,val);
                    })
                }
                if(module.type=='1'){
                    if(module.func&&module.func.length>0){
                        let func = module.func||[];
                        func.forEach(item=>{
                            this._setChildrenVal(item,val);
                        })
                    }
                    if(module.fields&&module.fields.length>0){
                        let fields = module.fields;
                        fields.forEach(item=>{
                            this._setChildrenVal(item,val);
                        })
                    }
                    if(module.dimension&&module.dimension.length>0){
                        let dimension = module.dimension;
                        dimension.forEach(item=>{
                            this._setChildrenVal(item,val);
                        })
                    }
                }
            },
            _setFieldsChildrenVal(field,val){
                if(!field.disabled){
                    this.$set(field,'checked',val);
                }
                let children = field.children||[];
                children.forEach(item=>{
                    this._setFieldsChildrenVal(item,val);
                })
            },
            _findModuleById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _removeParentsChecked(module){
                console.log('removeParentChecked',1,module);
                let pid = module.pid;
                if(!pid) return;
                let targetModule =  this._findModuleById(this.operationConfig,pid);
                if(targetModule){
                    this.$set(targetModule,'checked',false);
                    this._removeParentsChecked(targetModule);
                }
            },
            _getCheckedVal(list,result){
                list.forEach(item=>{
                    if(item.checked){
                        result.push(item.id);
                    }
                    if(item.children&&item.children.length>0){
                        return this._getCheckedVal(item.children,result);
                    }
                    if(item.type=='1'){
                        let func = this._getCheckedVal(item.func,result);
                        let fields = this._getCheckedVal(item.fields,result);
                        let dimension = this._getCheckedVal(item.dimension,result);
                        let period = this._getCheckedVal(item.statistical_period||[],result);
                        result.concat(func,fields,dimension,period);
                    }
                });
                return result;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .min-height-300{
        min-height: 300px;
    }
    .rotate {
        transform: rotate(90deg);
    }
</style>
